

























































import {Component, Prop, Vue} from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import CPBtn from '@/components/buttons/CPBtn/CPBtn.vue';

import { strings } from '@/lib/stringConst';
import TabsNav from "@/components/tabs/TabsNavIcons.vue";

@Component({
    components: {
        TabsNav,
        Layout,
        CPBtn,
    },
})
export default class CRUDEditPage extends Vue {
    @Prop({ required: false }) readonly isNav?: boolean;
    @Prop({ required: false }) readonly tabsNav?: any;
    @Prop({ required: false }) readonly currentTab?: any;
    @Prop({ required: false }) readonly isRemovable?: boolean;
    @Prop({ default: true, type: Boolean }) readonly hasActions?: boolean;

    get text() {
        return strings;
    }

    action() {
        this.$emit('formSubmit');
    }

    cancel() {
        this.$emit('cancel');
    }

    remove() {
        this.$emit('remove');
    }
}
